import { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const SocialShare = ({ articleTitle, articleId }) => {
  const [copied, setCopied] = useState(false);

  const baseUrl = typeof window !== 'undefined' ? window?.location?.origin : '';
  const shareUrl = articleId
    ? `${baseUrl}/article/${articleId}`
    : (typeof window !== 'undefined' ? window?.location?.href : '');
  const shareText = `اقرأ: ${articleTitle}`;

  const shareOptions = [
    {
      id: 'facebook',
      name: 'فيسبوك',
      icon: 'Facebook',
      color: '#1877F2',
      url: `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
        shareUrl
      )}`
    },
    {
      id: 'whatsapp',
      name: 'واتساب',
      icon: 'MessageCircle',
      color: '#25D366',
      url: `https://wa.me/?text=${encodeURIComponent(
        `${shareText} ${shareUrl}`
      )}`
    }
  ];

  const handleCopyLink = async () => {
    try {
      await navigator?.clipboard?.writeText(shareUrl);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error('Failed to copy:', err);
    }
  };

  const handleShare = (url) => {
    window?.open(url, '_blank', 'width=600,height=400');
  };

  return (
    <div>
      <h3
        className="text-2xl text-center mb-6"
        style={{
          fontFamily: 'Aref Ruqaa, serif',
          color: '#2C2B29',
          fontWeight: 700
        }}
      >
        شارك المقال
      </h3>

      <div className="flex items-center justify-center gap-4 flex-wrap">
        {/* Share Buttons */}
        {shareOptions?.map((option) => (
          <button
            key={option?.id}
            onClick={() => handleShare(option?.url)}
            className="flex items-center gap-2 px-5 py-3 rounded-full transition-all duration-300 hover:scale-105 hover:shadow-warm-lg"
            style={{
              backgroundColor: `${option?.color}15`,
              border: `2px solid ${option?.color}30`
            }}
            aria-label={`مشاركة على ${option?.name}`}
          >
            <Icon name={option?.icon} size={20} color={option?.color} />
            <span
              className="text-sm font-medium"
              style={{
                fontFamily: 'Amiri, serif',
                color: option?.color
              }}
            >
              {option?.name}
            </span>
          </button>
        ))}

        {/* Copy Link Button */}
        <button
          onClick={handleCopyLink}
          className="flex items-center gap-2 px-5 py-3 rounded-full transition-all duration-300 hover:scale-105 hover:shadow-warm-lg"
          style={{
            backgroundColor: copied
              ? 'rgba(125, 132, 113, 0.15)'
              : 'rgba(197, 160, 89, 0.1)',
            border: copied
              ? '2px solid rgba(125, 132, 113, 0.3)'
              : '2px solid rgba(197, 160, 89, 0.2)'
          }}
          aria-label="نسخ الرابط"
        >
          <Icon
            name={copied ? 'Check' : 'Link'}
            size={20}
            color={copied ? '#7D8471' : '#C5A059'}
          />
          <span
            className="text-sm font-medium"
            style={{
              fontFamily: 'Amiri, serif',
              color: copied ? '#7D8471' : '#C5A059'
            }}
          >
            {copied ? 'تم النسخ!' : 'نسخ الرابط'}
          </span>
        </button>
      </div>

      {/* Share Stats */}
      <div
        className="mt-8 text-center p-4 rounded-lg"
      >
        <p
          className="text-sm"
          style={{
            fontFamily: 'Amiri, serif',
            color: '#5A5A5A'
          }}
        >
          شارك هذا المقال مع أصدقائك وساعد في نشر المعرفة
        </p>
      </div>
    </div>
  );
};

export default SocialShare;